import * as React from 'react';

interface IProps {
    className?: string;
}

class CloseIcon extends React.Component<IProps> {
    public render() {
        return (
            <svg
                width="33"
                height="33"
                viewBox="0 0 33 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={this.props.className}>
                <path
                    d="M22.5 22.1018L10.5 10.1018M22.5 10.1018L10.5 22.1018"
                    stroke="white"
                    strokeOpacity="0.87"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                />
            </svg>
        );
    }
}

export default CloseIcon;
